import { createAction } from '@reduxjs/toolkit';

export const DELETE_CONTACT_ACTION_TYPE = 'saga/deleteContact';
export const deleteContactAction = createAction(DELETE_CONTACT_ACTION_TYPE);
